import * as React from "react"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Form from "@bappweb/form"
import Button from "@bappweb/button"
import { Sizes, useDeviceSize } from "@bappweb/provider"
import Page from "@components/globalmodules/page"
import BigLogoAkbank from "@components/globalmodules/logo/index-bigLogo"
import "./style.scss"
import { API_URLS } from "../../../constants/api/index"
import { useHistory } from "react-router-dom"


let responseData: { retCode: string, retMsg: string } = {
  retCode: "",
  retMsg: ""
}

const SftpChangePasswordError = () => {
  const { t } = useTranslation()
  const size = useDeviceSize()

  const [serviceResetPasswordReturn, setResertPsw] = useState("");
  const history = useHistory();

  useEffect(() => {
    setResertPsw(responseData.retCode);
  }, [serviceResetPasswordReturn]);


  const handleSubmit = React.useCallback(async (e, data) => {

    setResertPsw(responseData.retCode);
  }, [])

  const handleError = React.useCallback((e, errors) => {
    console.info(JSON.stringify(errors, void 0, 2))
  }, [])

  const handleSendPasswordClick = React.useCallback(() => {
   // window.location.href = API_URLS.FTP_URL;
     history.push("/");
  }, [])

  const main = useMemo(() => {

    return (

      <Block className="bapp-page-login-main">
        <Block className="bapp-page-login-main-wrapper">
          <Element type="h1" style={{ fontSize: "24px", fontFamily: "Campton", textAlign: "center", fontWeight: "550" }}>{t("Şifreniz değiştirilemedi")}</Element>
          <Element className="sftp-header" style={{ fontSize: "14px", fontFamily: "Campton", textAlign: "center", fontWeight: "475", lineHeight: "20px" }} >{t("Bilgileriniz Eşleşmemektedir, Bilgilerinizi Kontrol Ediniz")}</Element>

          <Form onSubmit={handleSubmit} onError={handleError} grid={false}>

            <Button text={t("Şifre İşlemleri")} type="submit" fullWidth onClick={handleSendPasswordClick} />
          </Form>
        </Block>
      </Block>
    )
  }, [handleError, handleSendPasswordClick, handleSubmit, t])

  return (
    <Page className="bapp-page-login" container={false} footer={false}>
      {size !== Sizes.xs ? (
        <>
          <Block className="" />
          <Block className="bapp-page-login-desktop-wrapper bapp-container">
            <Block>
              <BigLogoAkbank />

              <Image path={"/img/svg/drawer-icons-error.svg"} fallbackText={t("Correct")} />
              <Element className="sftp-header" style={{ fontSize: "34px", color: "black" }} type="h2" >{t("Your files are safe with the file sharing center")}</Element>
              <Element style={{ fontSize: "23px", color: "black" }}>{t("Akbank güvenli dosya transferi ile FTP dosyalarını güvenli bir şekilde aktarabilirsiniz.")} </Element>
            </Block>
            {main}
          </Block>
        </>
      ) : (
        main
      )}
    </Page>

  )
}

export default SftpChangePasswordError
